<template>
  <div>
    <PageLoader :storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#427D2D" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout wrap justify-center>
      <v-flex xs12>
        <v-layout wrap justify-start pa-4>
          <v-layout row justify-space-between align-center>
            <v-flex xs12 sm8 md8 lg8>
              <span class="heading">State Disaster Management Officers List</span>
            </v-flex>
            
            <v-flex xs12 sm4 md4 lg4 pt-2 pt-lg-0 pt-md-0 pt-sm-0 mt-2 class="text-right">
              <v-btn color="#427D2D" @click="openAddDialog()">
                <span style="font-size: 12px; font-family: poppinssemibold; color: white;">
                  Add State Disaster Officer
                  <v-icon color="white">mdi-plus</v-icon>
                </span>
              </v-btn>
            </v-flex>
          </v-layout>

          <v-flex xs12 v-if="userlist && userlist.length > 0" pt-4>
            <v-layout wrap justify-start pt-2>
              <v-flex xs12>
                <v-card>
                  <div style="overflow-y: auto;">
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left tablehead">Name</th>
                            <th class="text-left tablehead">User Name</th>
                            <th class="text-left tablehead">Phone</th>
                            <th class="text-left tablehead">Email</th>
                            <th class="text-left tablehead">Scope</th>
                            <th class="text-left tablehead" v-if="mainRole === 'admin'">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in userlist" :key="index">
                            <td style="white-space: nowrap;" class="tableitems">{{ item.name }}</td>
                            <td style="white-space: nowrap;" class="tableitems">{{ item.username }}</td>
                            <td style="white-space: nowrap;" class="tableitems">{{ item.phone }}</td>
                            <td style="white-space: nowrap;" class="tableitems">{{ item.email || '-' }}</td>
                            <td style="white-space: nowrap;" class="tableitems">
                              <v-chip small color="teal lighten-4" class="teal--text text--darken-3 font-weight-medium">State Level</v-chip>
                            </td>
                            <td style="white-space: nowrap;" v-if="mainRole === 'admin'">
                              <v-icon small color="primary" class="mr-2" @click="openEditDialog(item)">mdi-pencil</v-icon>
                              <v-icon small color="error" class="mr-2" @click="rejectDialog(item._id)">mdi-delete</v-icon>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 v-else pt-4>
            <v-card class="text-center pa-6" flat outlined>
              <v-icon size="48" color="grey lighten-1">mdi-account-off-outline</v-icon>
              <div class="subheading text-grey mt-2">No State Disaster Management Officers found</div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- Add Dialog -->
    <v-dialog v-model="adddialog" max-width="600px">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          <span style="font-size: 18px; font-family: poppinssemibold; color: black;">
            ADD STATE DISASTER MANAGEMENT OFFICER
          </span>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-layout wrap justify-start pt-2>
              <v-flex xs12 sm12 md6 lg6 pr-2 class="subheading">
                <span style="color:black">User Name</span>
                <v-text-field class="pt-2 text-des" outlined v-model="username" dense hide-details></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6 lg6 class="subheading">
                <span style="color:black">Name</span>
                <v-text-field class="pt-2 text-des" outlined v-model="name" dense hide-details></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6 lg6 pr-2 class="subheading pt-3">
                <span style="color:black">Phone Number</span>
                <v-text-field class="pt-2 text-des" outlined v-model="phone" dense hide-details type="number"></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6 lg6 class="subheading pt-3">
                <span style="color:black">Email</span>
                <v-text-field class="pt-2 text-des" outlined v-model="email" dense hide-details></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6 lg6 pr-2 class="subheading pt-3">
                <span style="color:black">Password</span>
                <v-text-field 
                  class="pt-2 text-des" 
                  outlined 
                  v-model="password" 
                  dense 
                  hide-details 
                  :type="showAddPassword ? 'text' : 'password'"
                  :append-icon="showAddPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showAddPassword = !showAddPassword"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6 lg6 class="subheading pt-3">
                <span style="color:black">Confirm Password</span>
                <v-text-field 
                  class="pt-2 text-des" 
                  outlined 
                  v-model="cpassword" 
                  dense 
                  hide-details 
                  :type="showAddCPassword ? 'text' : 'password'"
                  :append-icon="showAddCPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showAddCPassword = !showAddCPassword"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="adddialog = false">Close</v-btn>
          <v-btn color="blue darken-1" text @click="submitAdd()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Edit Dialog -->
    <v-dialog v-model="editdialog" max-width="600px">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          <span style="font-size: 18px; font-family: poppinssemibold; color: black;">
            EDIT STATE DISASTER OFFICER
          </span>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-layout wrap justify-start pt-2>
              <v-flex xs12 sm12 md6 lg6 pr-2 class="subheading">
                <span style="color:black">User Name</span>
                <v-text-field class="pt-2 text-des" outlined v-model="editUsername" disabled dense hide-details></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6 lg6 class="subheading">
                <span style="color:black">Name</span>
                <v-text-field class="pt-2 text-des" outlined v-model="editName" dense hide-details></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6 lg6 pr-2 class="subheading pt-3">
                <span style="color:black">Phone Number</span>
                <v-text-field class="pt-2 text-des" outlined v-model="editPhone" dense hide-details type="number"></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6 lg6 class="subheading pt-3">
                <span style="color:black">Email</span>
                <v-text-field class="pt-2 text-des" outlined v-model="editEmail" dense hide-details></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md12 lg12 class="subheading pt-3">
                <span style="color:black">New Password (leave blank to keep current)</span>
                <v-text-field 
                  class="pt-2 text-des" 
                  outlined 
                  v-model="editPassword" 
                  dense 
                  hide-details 
                  :type="showEditPassword ? 'text' : 'password'"
                  :append-icon="showEditPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showEditPassword = !showEditPassword"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="editdialog = false">Close</v-btn>
          <v-btn color="blue darken-1" text @click="submitEdit()">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Confirmation -->
    <v-dialog v-model="deletedialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>Are you sure you want to delete this State Disaster Officer?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="deletedialog = false">Cancel</v-btn>
          <v-btn color="error" text @click="submitDelete()">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "StateDisasterOfficersList",
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      userlist: [],

      adddialog: false,
      username: "",
      name: "",
      phone: "",
      email: "",
      password: "",
      cpassword: "",
      showAddPassword: false,
      showAddCPassword: false,

      editdialog: false,
      editId: null,
      editUsername: "",
      editName: "",
      editPhone: "",
      editEmail: "",
      editPassword: "",
      showEditPassword: false,

      deletedialog: false,
      deleteId: null,
    };
  },
  computed: {
    mainRole() {
      return this.$store.state.userRole;
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/statedisasterofficer/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.userlist = response.data.data;
          }
        })
        .catch((error) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(error);
        });
    },

    openAddDialog() {
      this.username = "";
      this.name = "";
      this.phone = "";
      this.email = "";
      this.password = "";
      this.cpassword = "";
      this.adddialog = true;
    },

    submitAdd() {
      if (!this.username || !this.name || !this.phone || !this.password) {
        this.msg = "Please fill all required fields";
        this.showSnackBar = true;
        return;
      }
      if (this.password !== this.cpassword) {
        this.msg = "Passwords do not match";
        this.showSnackBar = true;
        return;
      }

      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/statedisasterofficer/register",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          username: this.username,
          name: this.name,
          phone: this.phone,
          email: this.email,
          password: this.password,
          cpassword: this.cpassword,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.msg = response.data.msg;
          this.showSnackBar = true;
          if (response.data.status) {
            this.adddialog = false;
            this.getList();
          }
        })
        .catch((error) => {
          this.appLoading = false;
          this.msg = error.response && error.response.data && error.response.data.msg ? error.response.data.msg : "Error creating officer";
          this.showSnackBar = true;
        });
    },

    openEditDialog(item) {
      this.editId = item._id;
      this.editUsername = item.username;
      this.editName = item.name;
      this.editPhone = item.phone;
      this.editEmail = item.email || "";
      this.editPassword = "";
      this.editdialog = true;
    },

    submitEdit() {
      if (!this.editName || !this.editPhone) {
        this.msg = "Name and Phone are required";
        this.showSnackBar = true;
        return;
      }

      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/statedisasterofficer/edit",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.editId,
          name: this.editName,
          phone: this.editPhone,
          email: this.editEmail,
          password: this.editPassword,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.msg = response.data.msg;
          this.showSnackBar = true;
          if (response.data.status) {
            this.editdialog = false;
            this.getList();
          }
        })
        .catch((error) => {
          this.appLoading = false;
          this.msg = "Error editing officer";
          this.showSnackBar = true;
          console.log(error);
        });
    },

    rejectDialog(id) {
      this.deleteId = id;
      this.deletedialog = true;
    },

    submitDelete() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/districtofficer/delete",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.deleteId,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.deletedialog = false;
          this.msg = response.data.msg;
          this.showSnackBar = true;
          this.getList();
        })
        .catch((error) => {
          this.appLoading = false;
          this.msg = "Error deleting officer";
          this.showSnackBar = true;
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.heading {
  font-family: "poppinssemibold";
  font-size: 20px;
  color: #162a1c;
}
.tablehead {
  font-family: "poppinsmedium" !important;
  font-size: 13px !important;
  color: #555 !important;
}
.tableitems {
  font-family: "poppinsregular" !important;
  font-size: 13px !important;
}
</style>
